import { useState } from 'react';
import '../styles/Home.css';



const Login = () => {



  return (

    <div className="container">
      <h1>Welcome, you are logged in!</h1>
    </div>



  );
}
export default Login;
